import api from "./apiService";
import axios from "axios";
import imageCompression from "browser-image-compression";
import { ThumbnailType } from "constants/file";
import { ApiResponse } from "types";

/**
 * @deprecated "/files/upload"
 */
const uploadFile = async (
	file: File,
	folder: string,
	isObject = false,
	fileName = "",
	type?: string,
	shouldNotCompress?: boolean,
): Promise<any> => {
	try {
		if (
			file.type === "image/jpeg" ||
			file.type === "image/png" ||
			file.type === "image/gif"
		) {
			if (!shouldNotCompress) {
				file = await imageCompression(file, {
					maxSizeMB: 0.5,
					maxWidthOrHeight: 1500,
				});
			}
			file = new File([file], file.name, { type: type || file.type });
		}
		const form = new FormData();
		form.append("file", file);
		form.append("folder", folder);
		const {
			data: {
				data: { url, path },
			},
		} = await api.post<
			ApiResponse<{
				owner: number;
				type: string;
				folder: string;
				name: string;
				uuid: string;
				url: string;
				path: string;
				key: null;
				id: number;
				createdAt: string;
				updatedAt: string;
			}>
		>("/files/upload", form, true);
		if (path && url) {
			if (isObject) {
				return { path, url, fileName, type };
			}
			return JSON.stringify({ path, url });
		}
		return "";
	} catch (error) {
		return error;
	}
};

const getBase64 = (file: File): Promise<string> =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result as string);
		reader.onerror = error => reject(error);
	});

const uploadFileS3 = async (
	file: File,
	thumbnails?: Array<ThumbnailType>,
	mimeType?: string,
) => {
	try {
		const response = await api.post<ApiResponse<any>>("/files/get-upload-url", {
			fileName: file.name,
			mimeType: mimeType || file.type,
			thumbnails: thumbnails ?? [
				ThumbnailType.REACTANGLE_SM,
				ThumbnailType.REACTANGLE_MD,
				ThumbnailType.REACTANGLE_XL,
				ThumbnailType.REACTANGLE_XS,
			],
		});
		if (response) return response;
	} catch (error) {
		return error;
	}
};

const putFileS3 = async (
	file: File,
	callBack?: (progressEvent: any) => void,
	thumbnails?: Array<ThumbnailType>,
	mimeType?: string,
) => {
	try {
		const {
			data: {
				data: {
					uploadUrl,
					file: { url, path },
				},
			},
		}: any = await uploadFileS3(file, thumbnails, mimeType);

		if (uploadUrl && url) {
			const response = await axios({
				method: "PUT",
				url: uploadUrl,
				data: file,
				headers: {
					// Current hard-code mp4 (MOV is can not preview in link, just can download)
					"Content-Type": file.type?.includes("video")
						? "video/mp4"
						: file.type,
				},
				...(callBack && { onUploadProgress: callBack }),
			});
			if (response.status === 200) {
				return { url, path };
			}
		}
	} catch (error) {
		return error;
	}
};

const uploadNewsImage = async (file: File): Promise<any> => {
	try {
		const copiedFile = new File([file], file.name.replaceAll(/\s/g, ""), {
			type: file.type,
			lastModified: file.lastModified,
		});
		const form = new FormData();
		form.append("file", copiedFile);
		const {
			data: {
				data: { url, path },
			},
		} = await api.post<ApiResponse<{ url: string; path: string }>>(
			"/files/dashboard/upload",
			form,
			true,
		);
		if (url && path) {
			return { path, url };
		}
		return "";
	} catch (error) {
		return error;
	}
};

export default uploadFile;

export { uploadNewsImage, uploadFileS3, putFileS3, getBase64 };
